import {IMediaFileData} from "./MediaTypes";

enum MediaFileType {
    VideoSource = "video_source",
    VideoOutput = "video_output",
    SmilAdaptive = "smil_adaptive",
    Poster = "poster",
    Thumb = "thumb"
}

enum MediaStreamFileType {
    Poster = "poster",
    Thumb = "thumb",
    Offline = "offline_poster"
}

interface PosterThumbFiles {
    poster: IMediaFileData | null;
    thumb: IMediaFileData | null;
}

export {MediaFileType, MediaStreamFileType, PosterThumbFiles}